import { useEffect, useState } from 'react'
import { globalEmitter } from '../helpers/emitter'
import { CheckIcon } from '../icons/CheckIcon'
import { InfoIcon } from '../icons/InfoIcon'

export function Notification({ timeout = 5000 }: { timeout?: number }) {
  const [showNotification, setShowNotification] = useState(false)
  const [message, setMessage] = useState('')
  const [type, setMessageType] = useState('success')

  useEffect(() => {
    const handleNotification = (payload: { message: string; type: string }) => {
      setMessage(payload.message)
      setMessageType(payload.type)
      setShowNotification(true)

      const timer = setTimeout(() => {
        setShowNotification(false)
      }, timeout)

      return () => clearTimeout(timer)
    }

    globalEmitter.on('triggerNotification', handleNotification)

    return () => {
      globalEmitter.off('triggerNotification', handleNotification)
    }
  }, [timeout])

  return (
    <div
      className={`custom-notification fixed bottom-10 w-fit flex items-center justify-center left-1/2 z-[111] -translate-x-1/2 py-2.5 px-3.5 max-w-[calc(100%_-_48px)] bg-white border border-solid border-grey-900 ${
        showNotification ? 'block' : 'hidden'
      }`}
    >
      <div
        className={`flex items-center justify-center gap-2 uppercase font-calibre font-normal text-sm-d tracking-normal ${
          type === 'success' ? 'text-ink' : 'text-[#c9211b]'
        }`}
      >
        {type === 'success' ? <CheckIcon className="w-3 h-3 text-ink" /> : <InfoIcon className="w-3 h-3 text-[#c9211b]" />}
        <span className="flex-1">{message}</span>
      </div>
    </div>
  )
}
